const CountCard = ({ heading, count }) => {
  return (
    <div className="w-full shadow-100 rounded-md bg-white flex flex-col items-center justify-center py-[20px]">
      <label className="text-md font-normal text-gray-900 text-center">
        {heading}
      </label>
      <span className="text-xl font-bold">{count}</span>
    </div>
  );
};

export default CountCard;
